module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_resort_plans-61e5bba38babddd7e0ff7d39dcdd9196.jpg";